// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/update-sequence-number-request-schema',
  type: 'object',
  required: ['id', 'nextNumber'],
  properties: {
    id: {
      type: 'integer',
    },
    nextNumber: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
